/**
 * OVERRIDE SkipLinks.jsx
 */

import SkipLinks from '../../../../components/SkipLinks/SkipLinks';

export default SkipLinks;